<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead/>
            </div>
            <div class="carousel-box">
                <el-carousel interval="6000" indicator-position="none">
                    <el-carousel-item v-for="item in carouselList" :key="item">
                        <img class="top-img" :src="item.imgUrl" alt />
                        <h3 class="small">
                            <span v-if="!isLogin">励耘教研欢迎您！</span>
                            <span v-if="isLogin">{{this.timeInfo}}好，{{userInfo?userInfo.trueName:''}}老师！</span>
                        </h3>
                    </el-carousel-item>
                </el-carousel>
<!--                <div class="next-content">⇩</div>-->
            </div>
            <div class="home-content-box">
                <div class="content-box">
                    <div class="left-content">
                        <div class="banner-box">
                            <el-carousel interval="4000">
                                <el-carousel-item v-for="item in bannerList" :key="item" @click="handleBanner(item)">
                                   <img class="banner-img" :src="item.bannerUrl" alt />
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <!-- 新闻课题 -->
                        <div class="new-content">
                            <div class="title-box">
                                <div :class="isShowNewTopic==='news'?'title-name title-active':'title-name'" @click="changeNewTopic('news')">新闻资讯</div>
                                <div :class="isShowNewTopic==='topic'?'title-name title-active':'title-name'" @click="changeNewTopic('topic')">课题研究</div>
                                <div class="title-more" v-if="isShowNewTopic==='news'" @click="jumpPageHome('/lyedu/newscenter','homeNewsCentre','1')">更多>></div>
                                <div class="title-more" v-if="isShowNewTopic==='topic'" @click="jumpPageHome('/lyedu/tearesearch','homeTeachResearch','1')">更多>></div>
                            </div>
                            <!--新闻-->
                            <div class="news-item" v-show="isShowNewTopic==='news'" v-for="item in newsList.slice(0,4)" :key="item" @click="handleViewNews(item,'0')">
                                <div class="new-cover">
                                    <img :src="item.cover" alt />
                                </div>
                                <div class="news-title">
                                    <div class="news-title-name">{{item.title}}</div>
                                    <div class="news-title-time">{{ timestampToTime(item.releaseTime) }}</div>
                                </div>
                            </div>
                            <div class="div-100" v-if="isShowNewTopic==='news'&&newsList&&newsList.length===0">
                                <dataEmpty title="暂无新闻资讯" />
                            </div>
                            <!--课题-->
                            <div class="news-item" v-show="isShowNewTopic==='topic'" v-for="item in topicList.slice(0,4)" :key="item" @click="goToTopicDetail(item)">
                                <div class="topic-info-box">
                                    <div class="topic-status">
                                        <img src="../../assets/topic_sbz.png" alt>
                                    </div>
                                    <div class="topic-img">
                                        <img src="../../assets/topic_bg.png" alt>
                                    </div>
                                    <div class="topic-level">
                                        省级规划课题
                                    </div>
                                </div>
                                <div class="news-title">
                                    <div class="news-title-name">{{item.topicName}}</div>
                                    <div class="news-title-time">申报时间：{{ timestampToTime(item.applyBeginTime) }}-{{ timestampToTime(item.applyEndTime) }}</div>
                                </div>
                            </div>
                            <div class="div-100" v-if="isShowNewTopic==='topic'&&topicList&&topicList.length===0">
                                <dataEmpty title="暂无课题" />
                            </div>
                        </div>
                        <!-- 名师名校长 -->
                        <div class="new-content">
                            <div class="title-box">
                                <div :class="isShowGroupType==='ms'?'title-name title-active':'title-name'" @click="changeGroupShow('ms')">名师工作室</div>
                                <div :class="isShowGroupType==='mxz'?'title-name title-active':'title-name'" @click="changeGroupShow('mxz')">名校长工作室</div>
                                <div class="title-more" @click="jumpToStudioCenter" >更多>></div>
                            </div>

                            <div class="group-content">
                                <div class="group-item" v-for="item in groupList.slice(0,9)" :key="item" @click="viewStudioDetail(item)">
                                    <div class="group-one">
                                        <div class="group-name">
                                            {{item.groupName}}
                                        </div>
                                        <div class="group-subject" >
                                            {{item.periodName==''||item.periodName==null?'':item.periodName}}
                                            {{item.subjectName==''||item.subjectName==null?'':item.subjectName}}
                                        </div>
                                        <div class="group-cover-stats">
                                            <div class="group-cover">
                                                <img :src="item.groupAvatar" alt />
                                            </div>
                                            <div class="group-stats">
                                                <div class="stats-item">
                                                    成员：{{item.memberList.length}}
                                                </div>
                                                <div class="stats-item">
                                                    关注：{{item.careNum}}
                                                </div>
                                                <div class="stats-item">
                                                    成果：{{item.achieveNum}}
                                                </div>
                                                <div class="stats-item">
                                                    文章：{{item.articleNum}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="div-100" v-if="groupList&&groupList.length===0">
                                <dataEmpty title="暂无工作室" />
                            </div>
                        </div>
                    </div>

                    <div class="right-content">
                        <!--工作室活跃度-->
                        <div class="group-active-box">
                            <div class="title-box">
                                <div class="title-name title-active">工作室关注度</div>
<!--                                <div class="title-more" v-if="groupActiveList&&groupActiveList.length>10">更多>></div>-->
                            </div>
                            <div class="group-active-one" v-for="(item,index) in groupActiveList.slice(0,10)" :key="item">
                                <div :id="'num' + (index + 1)" class="group-active-index">{{index+1}}</div>
                                <div class="group-active-name" @click="goToStudioDetail(item)">{{item.groupName}}</div>
                                <div class="group-active-care">
                                    <span style="color:red;font-size: 15px;">{{item.careNum}}</span>人关注
                                </div>
                            </div>
                            <div class="div-100" v-if="groupActiveList&&groupActiveList.length===0">
                                <dataEmpty title="暂无数据" />
                            </div>

                        </div>

                        <!--工作室动态-->
                        <div class="group-trends-box">
                            <div class="title-box">
                                <div class="title-name title-active">工作室动态</div>
                                <div class="title-more" @click="jumpPageHome('/lyedu/trendscenter','homeTrendsCentre','1')">更多>></div>
                            </div>
                            <div class="group-article-one"  v-for="item in articleList.slice(0,10)" :key="item" @click="handleViewStudioNews(item)">
                                <div class="group-article-name">{{item.title}}</div>
                                <div class="group-article-belong">
                                    {{item.groupName}}
                                </div>
                            </div>
                            <div class="div-100" v-if="articleList&&articleList.length===0">
                                <dataEmpty title="暂无动态" />
                            </div>
                        </div>

                        <!--教研赛事-->
                        <div class="race-box">
                            <div class="title-box">
                                <div class="title-name title-active">教研赛事</div>
                                <div class="title-more" @click="jumpPageHome('/lyedu/tearesearch','homeTeachResearch','2')">更多>></div>
                            </div>
                            <div class="race-one" v-for="item in raceList.slice(0,10)" :key="item" @click="goToRaceDetail(item)">
                                {{item.raceName}}
                            </div>
                            <div class="div-100" v-if="raceList&&raceList.length===0">
                                <dataEmpty title="暂无赛事" />
                            </div>
                        </div>

                        <!--专题活动-->
                        <div class="race-box">
                            <div class="title-box">
                                <div class="title-name title-active">专题活动</div>
                                <div class="title-more"  @click="jumpPageHome('/lyedu/tearesearch','homeTeachResearch','3')">更多>></div>
                            </div>
                            <div class="race-one" v-for="item in activityList.slice(0,10)" :key="item" @click="goToActivityDetail(item)">
                                {{item.activityName}}
                            </div>
                            <div class="div-100" v-if="activityList&&activityList.length===0">
                                <dataEmpty title="暂无活动" />
                            </div>
                        </div>

                    </div>
                </div>
                <!--高水平示范课-->
                <div class="course-box">
                    <div class="title-box">
                        <div class="title-name title-active">高水平示范课</div>
                        <div class="title-more" @click="jumpPageHome('/lyedu/resource','homeResourceCentre','1')" >更多>></div>
                    </div>
                    <div class="course-list-box">
                        <div class="course-item" v-for="item in courseList.slice(0,9)" :key="item">
                            <el-card :body-style="{ padding: '0px' }" class="course-one" @click="goToCourseDetail(item)">
                                <div class="course-name">{{item.courseName}}</div>
                                <div class="course-info">
                                    <div class="course-cover">
                                        <img :src="item.courseCover" alt />
                                    </div>
                                    <div class="course-title">
                                        <div class="course-subject">{{item.periodName}}-{{item.gradeName}}-{{item.subjectName}}</div>
                                        <div class="course-subject">主讲人：{{item.userName?item.userName:'--'}}</div>
                                        <div class="course-subject">课程类型：高水平示范课</div>
                                        <div class="course-stats">
                                            <div class="stpBox">
                                                <img class="mr3"  style="width: 16px;height:16px" src="../../assets/image/dz.png" alt>
                                                {{ item.likeCount }}
                                            </div>
                                            <div class="stpBox">
                                                <el-icon class="mr3">
                                                    <Star/>
                                                </el-icon>
                                                {{ item.collectCount }}
                                            </div>
                                            <div class="stpBox">
                                                <el-icon class="mr3">
                                                    <View/>
                                                </el-icon>
                                                {{ item.viewCount }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                    <div class="div-100" v-if="courseList&&courseList.length===0">
                        <dataEmpty title="暂无课程" />
                    </div>
                </div>
                <!--成果-->
                <div class="achieve-box">
                    <div class="title-box">
                        <div class="title-name title-active">教科研成果</div>
                        <div class="title-more"  @click="jumpPageHome('/lyedu/tearesearch','homeTeachResearch','4')" >更多>></div>
                    </div>
                    <div class="achieve-list">
                        <div class="achieve-item" v-for="item in achieveList.slice(0,8)" :key="item" @click="goToAchieveDetail(item)">
                            <div class="achieve-cover">
                                <img :src="item.coverUrl" alt />
                            </div>
                            <div class="achieve-type-title">
                                <div class="achieve-type">{{item.achieveTypeName}}</div>
                                <div class="achieve-name">{{item.achieveTitle}}</div>
                            </div>
                        </div>
                        <div class="div-100" v-if="achieveList&&achieveList.length===0">
                            <dataEmpty title="暂无成果" />
                        </div>
                    </div>
                </div>

            </div>
            <div class="div-100">
                <home-footer />
            </div>

        </div>
    </div>
</template>
<script>
import {userMessages} from "@/api/admin/message";
import {listBanner,listNews,listTopic,listTeacherGroup,
    listHeadmasterGroup,listHighCourse,listAchieve,listGroupActive,
    listGroupTrends,listRace,listActivity} from '@/api/admin/welHome'
import {timestampToTime} from "@/utils/date";
import dataEmpty from "@/components/dataEmpty";
import homeHead from "@/components/homeHead";
import homeFooter from "@/components/homeFooter";

export default {
    components: {dataEmpty,homeHead,homeFooter},
    name: "welHome",
    data() {
        return {
            timestampToTime,
            isLogin:this.$storage.get('isLogin'),
            messageBol: false,
            systemBol: false,
            activePath: "welHome",
            isShowNewTopic:'news',
            isShowGroupType:'ms',
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            timeInfo:"",
            carouselList:[
                {imgUrl:'https://free-back.oss-cn-beijing.aliyuncs.com/carousel/ly01.jpg',title:'励耘教研'},
            ],
            bannerList:[],
            newsList:[],
            topicList:[],
            groupList:[],
            teaGroupList:[],
            headmasterGroupList:[],
            courseList:[],
            achieveList:[],
            groupActiveList:[],
            articleList:[],
            raceList:[],
            activityList:[]
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.isLogin){
            this.getMessage()
        }
        var currentDate = new Date();
        var currentHour = currentDate.getHours();
        if (0 <= currentHour && currentHour <= 6) {
            this.timeInfo = '凌晨'
        } else if (6 < currentHour && currentHour <= 12) {
            this.timeInfo = '上午'
        } else if (12 < currentHour && currentHour <= 18) {
            this.timeInfo = '下午'
        } else {
            this.timeInfo = '晚上'
        }
        this.listWelBanner();
        this.listWelNews();
        this.listWelTopic();
        this.listWelTeacherGroup();
        this.listWelHeadmasterGroup();
        this.listWelHighCourse();
        this.listWelAchieve();
        this.listWelGroupActive();
        this.listWelGroupTrends();
        this.listWelRace();
        this.listWelActivity();
    },
    mounted() {},
    methods: {
        userToLogin(){
            this.$router.push("/login")
        },
        getMessage() {
            userMessages({ code: 1 }).then(res => {
                this.systemBol = false;
                res.data.data.forEach(e => {
                    if (e.isRead === 0) {
                        this.systemBol = true;
                    }
                })
            });
            userMessages().then(res => {
                this.messageBol = false;
                res.data.data.forEach(e => {
                    if (e.isRead === 0) {
                        if (e.code !== 1) {
                            this.messageBol = true;
                        }
                    }
                })
            });
        },
        listWelBanner(){
            listBanner().then(res => {
                if (res.data.code === 1) {
                    this.bannerList = res.data.data;
                }
            });
        },
        changeNewTopic(name){
            this.isShowNewTopic = name;
        },
        listWelNews(){
            listNews().then(res => {
                if (res.data.code === 1) {
                    this.newsList = res.data.data;
                }
            });
        },
        listWelTopic(){
            listTopic().then(res => {
                if (res.data.code === 1) {
                    this.topicList = res.data.data;
                }
            });
        },
        changeGroupShow(type){
            this.isShowGroupType = type;
            this.groupList = [];
            if (type==='ms'){
                this.groupList = this.teaGroupList;
            }
            if (type==='mxz'){
                this.groupList = this.headmasterGroupList;
            }
        },
        jumpToStudioCenter(){
            if (this.isShowGroupType==='ms'){
                this.jumpPageHome('/lyedu/teastudio','teachStudioHome','2')
            }
            if (this.isShowGroupType==='mxz'){
                this.jumpPageHome('/lyedu/rectorstudio','rectorStudioHome','2')
            }
        },
        listWelTeacherGroup(){
            listTeacherGroup().then(res => {
                if (res.data.code === 1) {
                    this.teaGroupList = res.data.data;
                    this.groupList = this.teaGroupList;
                }
            });
        },
        listWelHeadmasterGroup(){
            listHeadmasterGroup().then(res => {
                if (res.data.code === 1) {
                    this.headmasterGroupList = res.data.data;
                }
            });
        },
        listWelHighCourse(){
            listHighCourse().then(res => {
                if (res.data.code === 1) {
                    this.courseList = res.data.data;
                }
            });
        },
        listWelAchieve(){
            listAchieve().then(res => {
                if (res.data.code === 1) {
                    this.achieveList = res.data.data;
                }
            });
        },
        listWelGroupActive(){
            listGroupActive().then(res => {
                if (res.data.code === 1) {
                    this.groupActiveList = res.data.data;
                }
            });
        },
        listWelGroupTrends(){
            listGroupTrends().then(res => {
                if (res.data.code === 1) {
                    this.articleList = res.data.data;
                }
            });
        },
        listWelRace(){
            listRace().then(res => {
                if (res.data.code === 1) {
                    this.raceList = res.data.data;
                }
            });
        },
        listWelActivity(){
            listActivity().then(res => {
                if (res.data.code === 1) {
                    this.activityList = res.data.data;
                }
            });
        },
        handleViewNews(item,type){
            let itemId = '';
            if (type==='1'){
                itemId = item.bannerId;
            }
            if (type==='0'){
                itemId = item.newsId;
            }
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/lyedu/news",
                query: {
                    signno: itemId,
                    type:type
                }
            });
            window.open(routeUrl.href, '_blank')
        },
        handleBanner(item){
            if (item.bannerLink===2){
                if (this.isLogin){
                    let link = item.content+"&uid="+this.userInfo.username;
                    window.open(link, '_blank')
                }else {
                    this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                        confirmButtonText: "去登录",
                        cancelButtonText: "取消",
                        type: "success"
                    }).then(() => {
                        this.userToLogin()
                    }).catch(()=>{
                        this.activePath = this.lastActivePath;
                    })
                }
            }else {
                //参数传递
                let routeUrl = this.$router.resolve({
                    path: "/lyedu/news",
                    query: {
                        signno: item.bannerId,
                        type:1
                    }
                });
                window.open(routeUrl.href, '_blank')
            }
        },
        handleViewStudioNews(item){
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/lyedu/studionews",
                query: {
                    signno: item.infoId,
                }
            });
            window.open(routeUrl.href, '_blank')
        },
        jumpPageHome(path,activePath,activeItem){
            if (this.isLogin){
                //参数传递
                this.$store.commit("params/setJumpParams", {activePath:activePath,activeItem: activeItem});
                this.$router.push({path: path,});
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        },
        viewStudioDetail(s){
            let path = 'teachStudioHome';
            if (this.isShowGroupType==='mxz'){
                path = 'rectorStudioHome';
            }
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '2',studioId:s.groupId,studioNature:s.groupNature});
            this.$router.push({path: "/lyedu/studiodetail"});
        },
        goToStudioDetail(s){
            let path = 'teachStudioHome';
            if (s.groupNature==='3'){
                path = 'rectorStudioHome';
            }
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '2',studioId:s.groupId,studioNature:s.groupNature});
            this.$router.push({path: "/lyedu/studiodetail"});
        },
        goToCourseDetail(c){
            const path = 'homeResourceCentre';
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '1',courseId:c.courseId});
            this.$router.push({path: "/lyedu/resource"});
        },
        goToAchieveDetail(a){
            const path = 'homeTeachResearch';
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '4',achieveId:a.achieveId});
            this.$router.push({path: "/lyedu/tearesearch"});
        },
        goToTopicDetail(item){
            const path = 'homeTeachResearch';
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '1',infoId:item.topicId});
            this.$router.push({path: "/lyedu/tearesearch"});
        },
        goToRaceDetail(item){
            const path = 'homeTeachResearch';
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '2',infoId:item.raceId});
            this.$router.push({path: "/lyedu/tearesearch"});
        },
        goToActivityDetail(item){
            const path = 'homeTeachResearch';
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '3',infoId:item.activityId});
            this.$router.push({path: "/lyedu/tearesearch"});
        },
    }
}
</script>
<!--内联样式-->
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
}
/deep/ .el-menu {
    height: 70px;
    border-bottom: none!important;
}
/deep/ .el-menu-item {
    font-size: 16px;
    height: 70px;
    padding: 10px 10px;
}
/deep/ .el-menu-item.is-active {
    font-weight: bold;
    font-size: 16px;
    border-bottom: none!important;
    background-color: #3b62f8;
    div{
        height: 30px;
        line-height: 30px;
        border-bottom: 2px solid #ffbf6b !important;
    }
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #3b62f8;
    }
}
/*轮播*/
.carousel-box{
    width: 100%;
    height: calc(100vh - 70px);
}
/deep/ .carousel-box .el-carousel{
    height: calc(100vh - 70px);
}
/deep/ .carousel-box .el-carousel__item{
    height: calc(100vh - 70px);
}
/deep/ .carousel-box .el-carousel__item h3 {
    color: #475669;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
    text-align: center;
}
/deep/ .carousel-box .el-carousel__item h3 span{
    position: absolute;
    top: -3%;
    left: 3%;
    font-size: 28px;
    color: #FFFFFF;
}
/*指示器按钮*/
/deep/ .el-carousel__button {
    width: 8px;
    height: 8px;
    border: none;
    border-radius: 50%;
    background-color: grey;
}
.small img {
    width: 100%;
    height:100%;
}
.top-img{
    width: 100%;
    height:100%;
    //object-fit: fill;
    object-fit: cover;
}
.next-content{
    position: absolute;
    left: 50%;
    bottom: 0;
    text-align: center;
    transform: translateX(-50%);
    color: #3b62f8;
    font-size: 48px;
    cursor: pointer;
    padding: 0 10px;
    animation: riseAndFade 2s linear 0s infinite;
    font-weight: bold;
}


/* 下降消失动画 */
@keyframes riseAndFade {
    100% {
        opacity: 0; /* 完全不透明 */
        transform: translateY(0); /* 初始位置，不移动 */
    }
    0% {
        opacity: 1; /* 完全透明 */
        transform: translateY(-10px); /* 向上移动100px */
    }
}
/*数据展示*/
.home-content-box{
    width: 100%;
    height: auto;
    background-color: #f1f1f1;
    padding: 20px 0 20px 0;
    //position: fixed;
    //left: 0;
    //top: 0;
    //bottom: 0;
    //right: 0;
    //transition: top 2.7s cubic-bezier(0.5,0,0.2,1) 0s;
    //z-index: 1;
    //overflow: auto;
    //outline: none;
}
.content-box{
    display: flex;
    width: 96%;
    height: auto;
    margin: auto;
    padding-bottom: 20px;
}
.left-content{
    display: block;
    width: 68%;
}
/*轮播信息*/
.banner-box{
    width: 98%;
    height: 300px;
    cursor: pointer;
}
/deep/ .banner-box .el-carousel{
    width: 100%;
    height: 100%;
}
/deep/ .banner-box .el-carousel .el-carousel-item{
    width: 100%;
    height: 100%;
}
.banner-img{
    width: 100%!important;
    height: 100%!important;
}
/*新闻资讯*/
.new-content{
    width: 98%;
    margin-top: 20px;
    background-color: #FFFFFF;
}
.news-item{
    display: flex;
    width: 98%;
    height: 135px;
    padding-top: 15px;
    padding-left: 15px;
    border-bottom: 1px solid #cecece;
    cursor: pointer;
}
.new-cover{
    width: 240px;
    height: 120px;
    img{
        width: 100%;
        height: 100%;
    }
}
.news-title{
    width: 100%;
    height: 120px;
    padding-left: 20px;
    cursor: pointer;
}
.news-title-name{
    width: 100%;
    height: 100px;
    cursor: pointer;
    font-size: 15px;
}
.news-title-name:hover{
    color: #3b62f8!important;
}
.news-title-time{
    width: 100%;
    height: 20px;
    font-size: 15px;
}
.topic-info-box{
    width: 240px;
    height: 120px;
    position: relative;
    border-radius: 8px;
    border: 1px solid #cecece;
}
.topic-status{
    position: absolute;
    width: 44px;
    height: 36px;
    z-index: 99;
    top: 2px;
    left: 2px;
    img{
        width: 100%;
        height: 100%;
    }
}
.topic-img{
    position: absolute;
    width: 72px;
    height: 72px;
    z-index: 9;
    top: 50px;
    right: 0;
    img{
        width: 100%;
        height: 100%;
    }
}
.topic-level{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
    font-size: 16px;
    font-weight: bold;
    color: #e87b17;
    text-align: center;
    line-height: 120px;
}
/*名师名校长*/
.group-content{
    display: flex;
    flex-wrap: wrap;
    width: 98%;
    height: auto;
    padding-left: 8px;
    padding-bottom: 10px;
    align-items: center;
}
.group-item{
    width: 33.3%!important;
    height: 180px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    border-radius: 10px;
}
.group-one{
    width: 100%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 10px;
    padding: 10px 0 10px 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.group-name{
    width: 95%;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    color: #333333;
}
.group-subject{
    width: 95%;
    height: 24px;
    line-height: 24px;
    background-color: #caa87b;
    color: #fff;
    font-size: 15px;
    text-indent: 5px;
}
.group-cover-stats{
    display: flex;
    width: 95%;
    height: auto;
}
.group-cover{
    //padding-left: 10px;
    margin-top: 10px;
    width: 80px;
    height: 80px;
    border-radius: 40px;
    img{
        width: 80px!important;
        height: 80px!important;
        border-radius: 40px;
    }
}
.group-stats{
    margin-top: 10px;
    height: 80px;
    padding-left: 30px;
    box-sizing: border-box;
    width: calc(100% - 80px);
}
.stats-item{
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #333333;
}
/*标题栏*/
.title-box{
    display: flex;
    width: 100%;
    height: 36px;
    border-bottom: 2px solid #3b62f8;
}
.title-name{
    width: auto;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    //color: #fff;
    //background-color: #cecece;
    color: #cecece;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.title-active{
    color: #3b62f8;
    //background: #3b62f8!important;
}
.title-more{
    color: #cecece!important;
    font-size: 15px;
    height: 36px;
    line-height: 36px;
    margin-left: auto;
    padding-right: 10px;
    cursor: pointer;
}
.title-more:hover{
    color: #3b62f8!important;
}

.right-content{
    width: 33%;
    height: auto;
}
.group-active-box{
    width: 98%;
    height: auto;
    background-color: #fff;
}
.group-active-one{
    display: flex;
    width: 98%;
    margin: auto;
    height: 40px;
    border-bottom: 1px dashed #cecece;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.group-active-index{
    width: 30px;
    line-height: 40px;
    text-align: left;
    font-size: 16px;
}
.group-active-name{
    line-height: 40px;
    font-size: 15px;
    width: calc(100% - 130px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
}
.group-active-care{
    width: 100px;
    line-height: 40px;
    text-align: right;
    color: #cecece!important;
    font-size: 15px;
}
#num1,
#num2,
#num3,
#num4,
#num5,
#num6,
#num7,
#num8,
#num9,
#num10 {
    background: none !important;
    font-size: 18px;
    font-weight: bold
}
#num1 {
    color: #ed574a;
}
#num2 {
    color: #f8b551;
}
#num3 {
    color: #32b16c;
}
#num4,
#num5,
#num6,
#num7,
#num8,
#num9,
#num10 {
    color: #86c8ff;
}

/*工作室动态*/
.group-trends-box{
    width: 98%;
    height: auto;
    background-color: #fff;
    margin-top: 20px;
}
.group-article-one{
    display: flex;
    width: 98%;
    margin: auto;
    height: 36px;
    border-bottom: 1px dashed #cecece;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.group-article-name{
    line-height: 36px;
    font-size: 15px;
    width: calc(100% - 140px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
}
.group-article-name:hover{
    color: #3b62f8;
}
.group-article-belong{
    width: 140px;
    line-height: 36px;
    text-align: right;
    color: #cecece!important;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*教研赛事*/
.race-box{
    width: 98%;
    height: auto;
    background-color: #fff;
    margin-top: 20px;
}
.race-one{
    width: 98%;
    margin: auto;
    height: 30px;
    //border-bottom: 1px dashed #cecece;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
    font-size: 15px;
    line-height: 30px;
}
.race-one:hover{
    color: #3b62f8;
}
/*高水平示范课*/
.course-box{
    width: 96%;
    height: auto;
    margin: auto;
    background-color: #fff;
    padding-bottom: 10px;
}

/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-left: 4px;
    padding-bottom: 10px;
    align-items: center;
}
.course-item{
    width: 33.3%!important;
    height: 190px;
    padding: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 120px;
}
.course-cover{
    width: 50%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 50%;
    height: 100%;
}
.course-name{
    box-sizing: border-box;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 15px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    //line-height: 30px;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    font-size: 16px;
    color: #333333;
    height: 60px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
}
.course-stats{
    width: 100%;
    height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.stpBox {
    width: 33.3%;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
}
/*成果*/
.achieve-box{
    width: 96%;
    height: auto;
    margin: auto;
    background-color: #fff;
    padding-bottom: 10px;
    margin-top: 20px;
}
.achieve-list{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-left: 4px;
    padding-bottom: 10px;
    align-items: center;
}
.achieve-item{
    width: 25%!important;
    height: 220px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-type-title{
    display: flex;
    height: 30px;
    width: 100%;
    margin-top: 10px;
}
.achieve-type{
    height: 24px;
    width: 40px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
    background-color: #3b62f8;
    border-radius: 4px;
    //font-weight: bold;
}
.achieve-name{
    height: 24px;
    width: calc(100% - 40px);
    color: #333;
    font-size: 15px;
    text-align: left;
    line-height: 24px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-indent: 5px;
}
</style>
